import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DECLARACAO_EMPFIN } from '../../../../app.constants';
import { ContratoModel } from '../../../shared/models/contatros.model';
import { DeclIrSefModel } from '../../../shared/models/declIrSef.model';



@Injectable()
export class DeclaracaoRendimentoEmpFinService {


    constructor(private httpClient: HttpClient) { }

    getUltimaDataReferenciaISW(centrus) {
      return this.httpClient
        .get<number>(`${DECLARACAO_EMPFIN}/ultimaDataReferenciaISW/${centrus}`)
        .toPromise();
    }

    getObterContratosFin(cdCentrus, anobase) {
      return this.httpClient
        .get<Array<ContratoModel>>(`${DECLARACAO_EMPFIN}/obterContratosFin/${cdCentrus}/${anobase}`)
        .toPromise();
    }

    getObterContratosEmp(cdCentrus, anobase) {
      return this.httpClient
        .get<Array<ContratoModel>>(`${DECLARACAO_EMPFIN}/obterContratosEmp/${cdCentrus}/${anobase}`)
        .toPromise();
    }

    getObterDeclIrSef(cdCentrus, tpEmpFin, nrContrato, dtLancto) {
      return this.httpClient
        .get<DeclIrSefModel>(`${DECLARACAO_EMPFIN}/obterDeclIrSef/${cdCentrus}/${tpEmpFin}/${nrContrato}/${dtLancto}`)
        .toPromise();
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/declaracao-rendimento-emp-fin/service/declaracao-rendimento-emp-fin.service.ts